import Component from "../../lib/component";

export const ImageAttacherConfig = {
    componentTypeKey: 'ImageAttacher',
    baseHtmlClass: 'image_attacher',
    selector: '.image_attacher',

    datasetConfigKey: 'image_attacher__config',
    minWidthDatasetConfigKey: 'min_width',
    minHeightDatasetConfigKey: 'min_height',
    previewElementIdDatasetConfigKey: 'preview_element_id',
};

export class ImageAttacher extends Component {

    constructor(id_or_element) {
        super({
            element: id_or_element,
            config: ImageAttacherConfig
        });

        this.setDatasetConfig(ImageAttacherConfig.datasetConfigKey);
        this.minWidth = this.getMinWidthConfig();
        this.minHeight = this.getMinHeightConfig();
        this.previewElementId = this.getDatasetConfigValue(ImageAttacherConfig.previewElementIdDatasetConfigKey);

        this.fileReader = null;
        this.file = null;
        this.imageWidth = null;
        this.imageHeight = null;

        this.validationErrors = [];

        this.element.addEventListener('change', this.handleChange.bind(this));

        this.render();
    }

    handleChange() {
        this.file = this.getFile();

        if (this.file && this.file.type.startsWith("image/")) {
            if (typeof window.FileReader !== 'function') return; // File API not supported
            this.fileReader = new FileReader();
            this.fileReader.onload = this.handleFileLoad.bind(this);
            this.fileReader.readAsDataURL(this.file);
        } else {
            this.file = null;
        }
    }

    getFile() {
        if (this.element.files) return this.element.files[0];
        return null;
    }

    handleFileLoad(event) {
        let fileResult = this.fileReader.result;

        let imgElement = createImageElement();
        imgElement.onload = () => {
            this.imageWidth = imgElement.width;
            this.imageHeight = imgElement.height;

            this.validate();
            this.render();

            imgElement.parentNode.removeChild(imgElement); // Clean up the DOM after itself.
        }

        try {
            imgElement.src = fileResult;
        } catch (error) {
            return;
        }
    }

    validate() {
        this.validationErrors = [];

        if (this.minWidth && this.imageWidth) {
            if (this.imageWidth < this.minWidth) {
                this.validationErrors.push(`Image width must be ${this.minWidth} pixels or more. The image is ${this.imageWidth} pixels wide.`);
            }
        }

        if (this.minHeight && this.imageHeight) {
            if (this.imageHeight < this.minHeight) {
                this.validationErrors.push(`Image height must be ${this.minHeight} pixels or more. The image is ${this.imageHeight} pixels high.`);
            }
        }

    }

    isValid() {
        return this.validationErrors.length === 0;
    }

    hasFile() {
        return !!this.file;
    }

    render() {
        this.conditionallySetHtmlClassState(this.hasFile(), 'has_file');
        this.swapHtmlClassStates(this.isValid(), 'valid', 'invalid');
        this.renderPreviewElement();
        this.renderValidationErrors();
    }

    renderValidationErrors() {
        let errorsElement = this.element.parentNode.querySelector('.inline-errors');
        if (!errorsElement) {
            errorsElement = document.createElement('p');
            errorsElement.classList.add('inline-errors');
            this.element.parentNode.insertBefore(errorsElement, null);
        }

        if (this.hasFile() && this.validationErrors) {
            errorsElement.innerHTML = this.validationErrors.join(". ");
        } else {
            errorsElement.innerHTML = "";
        }
    }

    renderPreviewElement() {
        if (!this.previewElementId) return;
        const previewElement = document.getElementById(this.previewElementId);
        if (previewElement && this.fileReader) {
            previewElement.querySelector('img').src = this.fileReader.result;
        }
    }

    getMinWidthConfig() {
        let minWidth = this.getDatasetConfigValue(ImageAttacherConfig.minWidthDatasetConfigKey);
        minWidth = parseInt(minWidth);
        if (!minWidth) return;
        return minWidth;
    }

    getMinHeightConfig() {
        let minHeight = this.getDatasetConfigValue(ImageAttacherConfig.minHeightDatasetConfigKey);
        minHeight = parseInt(minHeight);
        if (!minHeight) return;
        return minHeight;
    }

}

function createImageElement() {
    let img = document.createElement('img');
    img.style.display = 'none';
    document.body.appendChild(img);
    return img;
}